// extracted by mini-css-extract-plugin
export default {"section-header-con":"KN0Us_section-header-con"};